import { createSelector } from 'reselect';
import { selectAllCategories } from './selectAllCategories';

const filtration = (categories) =>
  categories.filter((category) => category.block === 'Спецпредложение');

export const selectSpecialOffersCategories = createSelector(selectAllCategories, filtration);
